<template>
  <div class="dropdown-row" :class="{ headingRow: isHeading }" @mousemove="onHover">
    <CheckboxGeneralDropdown :id="id" :checked="checked" @toggle="onToggle" />
    <span :class="{ heading: isHeading }" class="text">
      {{ value }}
    </span>
    <div v-if="circleColor" class="circle" :style="{ backgroundColor: circleColor }" />
    <img v-if="iconSource" class="icon-container" :src="iconSource" />
    <div v-if="showHoverExplanationText" class="hover-explanation">
      <p class="hover-explanation-text">
        {{ value }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, toRefs } from 'vue'
import CheckboxGeneralDropdown from '@/components/general/selectors/DropdownDashboard/Checkbox/CheckboxGeneralDropdown.vue'

interface Props {
  id: string | null
  checked: boolean
  value: string
  circleColor?: string
  iconSource?: string
  isHeading?: boolean
}
const props = defineProps<Props>()
const emits = defineEmits<{ (e: 'toggleOption', id: string): void }>()
const { id, checked, value, circleColor, iconSource, isHeading } = toRefs(props)
const showHoverExplanationText = ref(false)
const onToggle = (id: string) => {
  emits('toggleOption', id)
}
const onHover = (event: MouseEvent | TouchEvent) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const targetEl = event.target as HTMLElement
  //showHoverExplanationText.value = targetEl.offsetWidth < targetEl.scrollWidth
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss';

.dropdown-row {
  height: 40px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 10px;
  font-weight: 600;
  font-size: 16px;
  background-color: variables.$color-grey-blue-dark;
  color: variables.$color-text-white-70;
}
.text {
  max-width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.headingRow:not(:first-child) {
  margin-top: 15px;
}
.heading {
  font-size: 18px;
}
.hover-explanation {
  position: absolute;
  left: 0;
  bottom: -50%;
  width: 100%;
  z-index: 10;
  text-align: center;
  border-radius: 4px;
  padding: 2px 5px;
  background-color: rgba(0, 0, 0, 0.8);
  box-shadow: variables.$box-shadow-overview-button;
  &-text {
    color: variables.$color-text-white-70;
    margin: 0;
    font-size: 12px;
  }
}
.circle {
  border: solid 2px variables.$color-grey-lighter;
  border-radius: 50%;
  height: 18px;
  width: 18px;
  margin-left: auto;
}
.icon-container {
  height: 22px;
  margin-left: auto;
}
</style>
